<script setup lang="ts">
const props = withDefaults(defineProps<{ filled?: boolean; size?: string; color?: string }>(), {
  filled: false,
  size: undefined,
  color: undefined,
});
</script>

<template>
  <svg
    v-if="filled"
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M4.75 3a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5H4.75ZM10 5.5c.2 0 .4.08.53.22l4 4a.75.75 0 1 1-1.06 1.06l-2.72-2.72v8.19a.75.75 0 0 1-1.5 0V8.06l-2.72 2.72a.75.75 0 1 1-1.06-1.06l4-4A.75.75 0 0 1 10 5.5Z"
    />
  </svg>
  <svg
    v-else
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M4.5 3a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11ZM10 5.54c.13 0 .26.05.35.15l4 4a.5.5 0 0 1-.7.7L10.5 7.26v9.2a.5.5 0 0 1-1 0v-9.2L6.35 10.4a.5.5 0 1 1-.7-.71l4-4a.5.5 0 0 1 .35-.15Z"
    />
  </svg>
</template>
